<template>
    <div @click="$emit('view-preview')">
        <div v-if="imageCount == 1">
            <div v-for="(image, k) in images" :key="k">
                <img width="100%" :src="getImage(image.photo_uri)" alt=" "/>
            </div>
        </div>
        <div v-else-if="imageCount >= 2 && imageCount <= 3" class="tile-image-ui">
            <div v-for="(image, k) in images" :key="k">
                <img width="100%" height="100%" :src="getImage(image.photo_uri)" alt=" "/>
            </div>
            <div style="background: #333" v-show="imageCount === 3" />
        </div>
        <div v-else class="tile-image-ui">
            <div v-for="(image, k) in images" :key="k" v-show="k <= 3" style="position:relative">
                <img width="100%" height="100%" :src="getImage(image.photo_uri)" alt=" "/>
                <span v-if="k == 3 && imageCount > 4" class="image-float">
                    <span>+ {{imageCount - 4}}</span></span>
            </div>
        </div>
    </div>
</template>

<style>
    .image-float > span { 
        padding: 3px 5px;
        background: rgba(255,255,255,.8);
        border-radius: 5px;
    }
    .image-float {
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        top: 0;
        bottom: 0;
        z-index: 1;
        line-height: 200px;
    }
    .tile-image-ui {
        display: flex;
        flex-wrap: wrap;
    }
    .tile-image-ui > div > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    .tile-image-ui > div {
        border: 2px solid #fff;
        position:relative;
        flex-grow: 1;
        flex-shrink: 0;
        background: #fff;
        max-width: 50%;
        height: 200px;
        overflow: hidden;
    }
</style>

<script>
import Utils from '@/utils.js'

export default {
    props: {
        images: {
            required: true
        }
    },
    computed: {
        imageCount() {
            return (this.images) ? this.images.length : 0;
        }
    },
    methods: {
        getImage(uri) {
            return `${process.env.VUE_APP_BASE_IMAGE_URL}large${uri}`
        }
    }
}
</script>
